import axios from 'axios'
import { baseUrl } from './config'

export function getHistoryRequest (params) {
  const finalParams = { ...params }
  if (!finalParams.sort)
    finalParams.sort = 'created_at:desc'

  return axios.get(`${baseUrl}/history-requests`, { params: finalParams })
}

export function getHistoryRequestCategories () {
  return axios.get(`${baseUrl}/history-requests/categories`)
}
